import { uri } from '../utils/config';
import { HTTP } from './secure/http';

export const deleteToppingGroup = async (placeId, toppingGroupId) => {
  if (!placeId || !toppingGroupId) {
    console.log('NO PLACE ID');
    return;
  }

  await HTTP.delete({
    path: `${uri.api}/place/${placeId}/toppings-groups/${toppingGroupId}/delete`,
  });
};